import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLoading } from "../../context/LoadingContext";
import "./BranchDetails.scss";
import { getBranchDetailsById } from "../../services/api/BranchApi";
import { getMembers } from "../../services/api/MemberApi";
import { IoGrid } from "react-icons/io5";
import { FaTableList } from "react-icons/fa6";

export const BranchDetails = () => {
  const { branchId } = useParams();
  const [viewMode, setViewMode] = useState("table");
  const navigate = useNavigate()
  const [branchData, setBranchData] = useState(null);
  const [members, setMembers] = useState([]);
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        showLoading();
        const response = await getBranchDetailsById(branchId);
        const data = response.data?.result?.branchData;
        setBranchData(data);

        const userIds = data?.user || [];
        const userResponses = await Promise.all(userIds.map(id => getMembers(id)));
        const userDetails = userResponses.map(res => res.data);
        setMembers(userDetails);
      } catch (error) {
        console.error("Failed to fetch branch or members:", error);
      } finally {
        hideLoading();
      }
    };

    if (branchId) fetchBranch();
  }, [branchId]);

  if (!branchData) return showLoading()

  return (
    <div className="branch-details-container">
      <div className="branch-main-det">
      <h3><span>{branchData.branchName}</span>  -- Members in this Branch</h3>
      <div className="view-toggle-wrapper">
        <button
          className={`view-toggle-btn ${viewMode === "grid" ? "active" : ""}`}
          onClick={() => setViewMode("grid")}
        >
          <IoGrid />
        </button>
        <button
          className={`view-toggle-btn ${viewMode === "table" ? "active" : ""}`}
          onClick={() => setViewMode("table")}
        >
          <FaTableList />
        </button>
      </div>
      </div>
      {members.length === 0 ? (
        <p className="empty">No members found.</p>
      ) : viewMode === "grid" ? (
        <div className="members-grid">
          {members.map((member) => (
            <div key={member._id} className="member-card" onClick={() => navigate(`/home/addusers/${member._id}`)}>
              <div className="member-card-header">
                <h4 className="member-name">{member.name}</h4>
                <span className="role-badge">{member.role}</span>
              </div>
              <div className="member-details">
                <p><strong>Email:</strong> {member.email}</p>
                <p><strong>Phone:</strong> {member.phno}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <table className="members-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Role</th>
            </tr>
          </thead>
          <tbody>
            {members.map((member) => (
              <tr key={member._id} onClick={() => navigate(`/home/addusers/${member._id}`)}>
                <td>{member.name}</td>
                <td>{member.email}</td>
                <td>{member.phno}</td>
                <td><span className="role-badge">{member.role}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
